import React from 'react';
import { createPortal } from 'react-dom';
import { BallTriangle } from 'react-loader-spinner';

const overlayStyle = {
  position: 'fixed',
  inset: 0,
  width: '100vw',
  height: '100vh',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  backgroundColor: 'rgba(255, 255, 255, 0.55)',
  backdropFilter: 'none',
  WebkitBackdropFilter: 'none',
  zIndex: 20000,
  pointerEvents: 'auto',
};

const LoadingHome = () => {
  if (typeof document === 'undefined') {
    return null;
  }

  return createPortal(
    <div style={overlayStyle}>
      <div className="rotate-wrapper">
        <BallTriangle
          height={100}
          width={100}
          radius={5}
          color="#4fa94d"
          ariaLabel="ball-triangle-loading"
          wrapperClass={{}}
          wrapperStyle={{}}
          visible
        />
      </div>
    </div>,
    document.body
  );
};

export default LoadingHome;
